import { render, staticRenderFns } from "./SortBy.vue?vue&type=template&id=0671ee9a&"
import script from "./SortBy.vue?vue&type=script&lang=js&"
export * from "./SortBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports